import * as Firebase from 'firebase';

export default async function(email: string) {

  await Firebase.auth().sendPasswordResetEmail(email);

}



// WEBPACK FOOTER //
// ./src/services/firebaseRecoverPassword.ts